<template>
  <div tabindex="0" class="theme" :class="{ selected }" @click="onThemeUpdate(theme)">
    <div class="icon"><img :src="`images/icons/${theme.slug}.svg`" /></div>
    <div class="name">{{ theme.name }}</div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ButtonTheme",

  props: {
    theme: Object,
  },

  computed: {
    ...mapState({
      selectedThemes: (state) => state.selectedThemes,
    }),

    selected() {
      return this.selectedThemes.includes(this.theme.name);
    },
  },

  methods: {
    ...mapActions(["onThemeUpdate"]),
  },
};
</script>

<style lang="scss" scoped>
.theme {
  cursor: pointer;
  width: 100%;
  border-radius: $border-radius;
  color: $blue;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @include type-strong;
  transition: border 0.3s;

  &:not(.selected) {
    border: 5px solid $lightblue;
  }

  &.selected {
    border: 5px solid $blue;
  }
}

.icon {
  width: 50%;
  padding-bottom: 50%;
  margin: 10px auto;
  position: relative;
}

img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: contain;
}

.name {
  margin-top: 1em;
  line-height: 1.2;
}
</style>
